import React from 'react';
import { Icon } from '@frontend/icons';
import { Text } from '../../text';
import { ActionPressedChip } from '../atoms';
import { flexCenter } from '../common-styles';

type StrikethroughActionProps = Omit<React.ComponentProps<typeof ActionPressedChip>, 'children'>;

export const StrikethroughAction = ({ compact = true, showBoxShadow = true, ...rest }: StrikethroughActionProps) => {
  return (
    <ActionPressedChip {...rest} compact={compact} showBoxShadow={showBoxShadow}>
      <Text as='strong' weight='bold' className={flexCenter}>
        <Icon name='strikethrough-small' />
      </Text>
    </ActionPressedChip>
  );
};
